import React, { ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/Components/shadcn/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/Components/shadcn/tooltip';

export interface ImageCropSelectButtonProps {
    selectButtonTooltipText: string;
    children: ReactNode;
    removeButton: ReactNode;
    className?: string;
    onClick: () => void;
    disabled: boolean;
}

export const ImageCropSelectButton = ({
    children,
    removeButton,
    className,
    onClick,
    disabled,
    selectButtonTooltipText,
}: ImageCropSelectButtonProps): React.JSX.Element => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div className="relative">
                        <Button
                            type="button"
                            data-cy="ImageCropSelectButton"
                            variant="outline"
                            onClick={onClick}
                            disabled={disabled}
                            className={`bg-background hover:bg-accent size-17.5 overflow-hidden rounded-full p-0 disabled:opacity-100 ${className ?? ''}`}
                        >
                            {disabled ? children : <Plus className="text-primary size-6" aria-hidden />}
                        </Button>
                        {disabled && <div className="absolute -top-2 -right-2">{removeButton}</div>}
                    </div>
                </TooltipTrigger>
                {!disabled && (
                    <TooltipContent side="top">
                        <span className="text-xs">{selectButtonTooltipText}</span>
                    </TooltipContent>
                )}
            </Tooltip>
        </TooltipProvider>
    );
};
